/* tslint:disable */
export var icon = "\n<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"19\" height=\"19\"><g fill=\"#EE5951\"><path d=\"M9.5 18.5a9 9 0 110-18 9 9 0 010 18zm0-1a8 8 0 100-16 8 8 0 000 16z\"/><path d=\"M5 10h9V9H5z\"/></g></svg>\n";
//# sourceMappingURL=delete-section.svg.js.map